import {ReactElement, useRef} from 'react';

import {Stack} from '@mantine/core';

import {useMessages} from '../hooks/useMessages';

import {
    MantineDataTable,
    SimpleTableBatchAction,
    DataTableTokenPagination,
} from '@flexinet/ui-components';
import {useMessagesSelection} from '../hooks/useMessagesSelection';
import {
    Message,
    MessageStatus,
} from '../types';
import {useMessagesSearch} from "../hooks/useMessagesSearch.ts";
import {useMessagesPaging} from "../hooks/useMessagesPaging.ts";
import {useMessagesTableColumns} from "../hooks/useMessagesTableColumns.tsx";
import {useAuth} from "../../../hooks/useAuth.ts";
import classes from './RecordsTable.module.css';
import {useNavigate} from "react-router-dom";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {DataTableColumn} from "mantine-datatable";
import {addToSelection} from '../reducers';
import {useAppDispatch} from '../../../hooks/useTypedReactRedux';
import {rbacActions} from "../../../config/rbac/actions.ts";


export const RecordsTable = (
    {
        records,
        extraTools,
        settings,
    }: {
        records?: Message[]
        extraTools?: ReactElement[],
        settings?: { label: string, onClick: () => void }[]
    }) => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch();


    const {
        user
    } = useAuth();


    if (!user) {
        throw new Error('user is required parameter')
    }

    const {allowedActions} = useVerifiedPermissions()

    const {
        visibleCount,
        nextToken,
        fetchRecords,
        isFetchingNextPage,
    } = useMessages();

    const scrollViewportRef = useRef<HTMLDivElement>(null);


    const {
        columns,
    } = useMessagesTableColumns();

    const {
        handleFilterByKeyword,
    } = useMessagesSearch();

    const {
        limit,
        handleItemsPerPageChange,
    } = useMessagesPaging();

    const {
        selection,
        handleClearSelection,
    } = useMessagesSelection();


    // const {
    //     updateRecord,
    // } = useMessage(selectedRecord?.id);


    let selectedRecords = [] as Message[];
    if (allowedActions.includes(rbacActions.DeleteMessage)) {
        selectedRecords = Object.keys(selection)
                                .map(key => selection[key])
    }


    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={handleItemsPerPageChange}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />


            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        dispatch(addToSelection(item as unknown as Message));
                    })
                }}
                onRowClick={({
                                 record,
                             }) => {

                    navigate('/messages/' + record.id);

                }}
                rowClassName={(record) => {
                    if (record.status === MessageStatus.UNREAD) {
                        return classes.unread;
                    } else if (record.status === MessageStatus.READ) {
                        return classes.read;
                    }
                }}
                fetching={false}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination
                loadedCount={visibleCount}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                isFetchingMore={isFetchingNextPage}
            />

        </Stack>
    );
};
